import React, { Component, Fragment } from 'react';
import ScrollToTop from 'react-scroll-up';
import ServiceTwo from './ServiceTwo';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import AboutTwo from './AboutTwo';
import BlogContent from './BlogContent';
import Header from '../../Layout/Main/header/Header';
import FooterTwo from '../../Layout/Main/footer/FooterTwo';
import ModalVideo from 'react-modal-video';
import { videoTagString, VideoTag } from 'react-video-tag';
import Helmet from './Helmet';
import Portfolio from './Portfolio';
import MovingJobSlider from './MovingJob';
import ExplainerVideo from '../../assets/images/service/VIDDYOZE-Delivery.mp4';
import { FiChevronUp, FiCast, FiLayers, FiUsers } from 'react-icons/fi';
import { Col, Form, InputGroup, Button } from 'react-bootstrap';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
import $ from 'jquery';

const styles = theme => ({
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	paper1: {
		width: '100vh',
		height: '40vh',
		boxShadow: 'black 0px 0px 20px 5px',
		borderRadius: '10px',
		backgroundColor: 'white',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
	paperCareer: {
		borderRadius: '10px',
		boxShadow: 'black 0px 0px 20px 5px',
		backgroundColor: 'white',
		width: '100vh',
		height: '50vh',
	},
	paperCareer2: {
		borderRadius: '10px',
		boxShadow: 'black 0px 0px 20px 5px',
		backgroundColor: 'white',
		width: '100vh',
		height: '30vh',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
	},
});

const SlideList = [
	{
		textPosition: 'text-left',
		category: '',
		title: 'Moonline Moving',
		description: 'Full service moving company located in Vancouver, BC',
		buttonText: 'Get Your Free Moving Estimate',
		buttonLink: '/clientinformation',
	},
];

function makeid(length) {
	var result = '';
	var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var charactersLength = characters.length;
	for (var i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}

class MoonlineHome extends Component {
	constructor() {
		super();
		this.state = {
			isOpen: false,
			OpenModal: false,
			OpenForm: false,
			openCupon: false,
			subscriptionFOrm: {
				firstName: '',
				lastName: '',
				email: '',
				phoneNumber: '',
			},
		};
		this.openModal = this.openModal.bind(this);
	}
	componentDidMount() {
		this.setState({
			OpenModal: true,
		});
	}
	handleOpen = () => {
		this.setState({ OpenModal: true });
	};
	handleClose = () => {
		this.setState({ OpenModal: false });
	};
	handleOpenForm = () => {
		this.setState({ OpenForm: true });
	};
	handleCloseForm = () => {
		this.setState({ OpenForm: false });
	};
	openModal() {
		this.setState({ isOpen: true });
	}
	submitSubscription = e => {
		e.preventDefault();
		this.setState({
			openCupon: true,
			OpenModal: false,
			OpenForm: false,
		});
	};
	subsFormChangeHandler = (name, value) => {
		this.setState(prevState => {
			return { subscriptionFOrm: { ...prevState.submitSubscription, [name]: value } };
		});
	};
	handleCloseCoupen = () => {
		this.setState({
			openCupon: false,
		});
	};
	render() {
		const { classes } = this.props;
		const PostList = BlogContent.slice(0, 3);
		return (
			<Fragment>
				<Helmet pageTitle='Studio Agency' />
				{/* Start Header Area  */}
				<Header />
				{/* End Header Area  */}
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					className={classes.modal}
					open={this.state.openCupon}
					onClose={this.handleCloseCoupen}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}>
					<Fade in={this.state.openCupon}>
						<div className={classes.paperCareer2}>
							<div className='text-center'>
								<h2 style={{ fontSize: '45px', marginTop: '2rem' }} id='transition-modal-title'>
									Your Coupen is <span style={{ color: '#de2828' }}>{makeid(5)}</span>
								</h2>
							</div>
						</div>
					</Fade>
				</Modal>
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					className={classes.modal}
					open={this.state.OpenModal}
					onClose={this.handleClose}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}>
					<Fade in={this.state.OpenModal}>
						<div className={classes.paper1}>
							<div className='text-center'>
								<h4 style={{ fontSize: '25px', marginTop: '2rem' }} id='transition-modal-title'>
									Subscribe for our Email List to Get 10% off on your next move
								</h4>
								<Button
									onClick={() => {
										this.handleOpenForm();
										this.handleClose();
									}}
									variant='primary'
									style={{ fontSize: '5vh', width: '36rem', padding: '2vh', background: '#de2828', marginTop: '2vh' }}>
									Subscribe
								</Button>
							</div>
						</div>
					</Fade>
				</Modal>
				<Modal
					aria-labelledby='transition-modal-title'
					aria-describedby='transition-modal-description'
					className={classes.modal}
					open={this.state.OpenForm}
					onClose={this.handleCloseForm}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500,
					}}>
					<Fade in={this.state.OpenForm}>
						<div className={classes.paperCareer}>
							<div className='text-center'>
								<h3 style={{ fontSize: '30px', marginTop: '2rem' }} id='transition-modal-title'>
									Have a Question? Let's help you
								</h3>
							</div>
							<Form onSubmit={this.submitSubscription} style={{ paddingLeft: '18vh', paddingRight: '18vh', paddingTop: '2vh' }}>
								<Form.Row>
									<Form.Group as={Col} controlId='formGridEmail'>
										<Form.Label>First Name</Form.Label>
										<Form.Control type='text' name='firstName' value={this.state.subscriptionFOrm.firstName} onChange={e => this.subsFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter your First Name' />
									</Form.Group>

									<Form.Group as={Col} controlId='formGridEmail'>
										<Form.Label>Last Name</Form.Label>
										<Form.Control type='text' name='lastName' value={this.state.subscriptionFOrm.lastName} onChange={e => this.subsFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter your Last Name' />
									</Form.Group>
								</Form.Row>

								<Form.Row>
									<Form.Group as={Col} controlId='formGridEmail'>
										<Form.Label>Email</Form.Label>
										<Form.Control type='email' name='email' value={this.state.subscriptionFOrm.email} onChange={e => this.subsFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter email' />
									</Form.Group>

									<Form.Group as={Col} controlId='formGridEmail'>
										<Form.Label>Phone Number</Form.Label>
										<Form.Control type='text' name='phoneNumber' value={this.state.subscriptionFOrm.phoneNumber} onChange={e => this.subsFormChangeHandler(e.target.name, e.target.value)} placeholder='Enter Phone Number' />
									</Form.Group>
								</Form.Row>

								<div className='text-center pt--30'>
									<Button
										disabled={this.state.subscriptionFOrm.firstName === '' || this.state.subscriptionFOrm.lastName === '' || this.state.subscriptionFOrm.email === ''}
										variant='primary'
										type='submit'
										style={{ width: '13rem', height: '7vh', border: '2px solid black', background: '#de2828' }}>
										Subscribe
									</Button>
									<h5 style={{ fontSize: '12px', position: 'absolute', bottom: '37px', left: '34%' }}>We work very hard to serve our clients, please give us 24-48 hours to call you back</h5>
								</div>
							</Form>
						</div>
					</Fade>
				</Modal>
				{/* Start Explainaer Video */}
				<div className='slider-wrapper' style={{ width: '100%' }}>
					{/* Start Video Description */}
					{SlideList.map((value, index) => (
						<div className='slide slide-style-2 slider-video-bg d-flex align-items-center justify-content-center' key={index}>
							<div className='container' id='VideoDescription'>
								<div className='row align-items-center'>
									<div className='col-lg-8'>
										<div className={`inner ${value.textPosition}`}>
											{value.category ? <span>{value.category}</span> : ''}
											{value.title ? <h1 className='title'>{value.title}</h1> : ''}
											{value.description ? <p className='description'>{value.description}</p> : ''}
											{value.buttonText ? (
												<div className='slide-btn'>
													<a className='rn-button-style--2 btn-primary-color' href={`${value.buttonLink}`}>
														{value.buttonText}
													</a>
												</div>
											) : (
												''
											)}
										</div>
									</div>
								</div>
							</div>
							<div className='video-background'>
								<VideoTag autoPlay={`${true}`} muted={`${true}`} playsInline={`${true}`} loop={`${true}`} src={ExplainerVideo} poster={`${'/assets/images/bg/bg-image-24.jpg'}`} />
							</div>
						</div>
					))}
					{/* End Video Description */}
				</div>
				{/* End Explainer Video   */}
				{/* Start Why Choose Us */}
				<div className='service-area creative-service-wrapper ptb--120 bg_color--1' id='service'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-12 col-12'>
								<div className='section-title text-left mb--30'>
									<h2 style={{ fontSize: '45px' }}>Our Services</h2>
									<p style={{ fontSize: '25px' }}>
										We are a go-to choice for families and companies when it comes to moving services. With our ethical and professional business practices, we make your move comfortable and effortless. We are committed to providing you with a positive moving experience.
									</p>
									<p style={{ fontSize: '25px' }}>We offer a wide array of moving services including</p>
								</div>
							</div>
						</div>
						<div className='row creative-service'>
							<div className='col-lg-12'>
								<AboutTwo item='9' column='col-lg-3 col-md-6 col-sm-6 col-12 text-left' />
							</div>
						</div>
					</div>
				</div>
				{/* End Why Choose Us */}
				{/* Start Why Choose Us */}
				<div className='service-area creative-service-wrapper pt--120 bg_color--1' id='service'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-12 col-12'>
								<div className='section-title text-left mb--30'>
									<h2 style={{ fontSize: '45px' }}>Why Choose Us?</h2>
								</div>
							</div>
						</div>
						<div className='row creative-service'>
							<div className='col-lg-12'>
								<ServiceTwo item='8' column='col-lg-12 col-md-12 col-sm-12 col-12 text-left' />
							</div>
						</div>
					</div>
				</div>
				{/* End Why Choose Us */}
				{/*Stare We Offer */}
				<div className='service-area creative-service-wrapper ptb--120 bg_color--1' id='service'>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-6 col-12'>
								<div className='section-title text-left mb--30'>
									<h2 style={{ fontSize: '45px' }}>We Offer</h2>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-lg-12 col-12'>
								<div id='bubble'>
									<iframe src='./bubbles/'  scrolling="no" width="100%" height="500px" frameborder='0'></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/*end We Offer */}
				{/* Start Review Slider */}
				<div className='portfolio-area ptb--40 bg_color--1'>
					<div className='portfolio-sacousel-inner mb--55 mb_sm--30'>
						<Portfolio />
					</div>
				</div>
				{/* End Review Slider */}
				{/* Our Values */}
				{/* <div className="service-area creative-service-wrapper ptb--120 bg_color--1" id="service">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-12">
                                <div className="section-title text-left mb--30">
                                    <h2>Our Values</h2>
                                    <p>We are also known for our values. We treat your belongings as our own when you choose us as your moving partner. All our staff is well educated and trained. You can be sure that your belongings will be safe and secure in our hands. We don’t interfere with your privacy and your products will be moved to your destination as they were packed in front of your eyes. We work for the satisfaction of our customers so we always go an extra mile with our services.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
				{/* Start CounterUp Area */}
				{/* <div className="rn-counterup-area pt--25 pb--110 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
				{/* End CounterUp Area */}
				{/* Start Testimonial Area */}
				{/* <div className="rn-testimonial-area bg_color--5 ptb--20"  style={{paddingTop:'10vh',paddingBottom:'10vh'}}>
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
				{/* End Testimonial Area */}
				{/* Start Moving Jobs Slider Area */}
				{/* <div className="portfolio-area ptb--120 bg_color--1">
                    <div className="portfolio-sacousel-inner mb--55 mb_sm--30">
                        <MovingJobSlider />
                    </div>
                </div> */}
				{/* End Moving Jobs Slider Area */}
				{/* Start Blog Area */}
				{/* <div className="rn-blog-area pt--120 bg_color--1">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-6">
                                <div className="section-title text-left">
                                    <h2>Latest News</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                                <div className="blog-btn text-left text-lg-right mt_sm--10 mt_md--10">
                                    <a className="btn-transparent rn-btn-dark" href="/blog"><span className="text">View All News</span></a>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--60 mt_sm--30">
                            {PostList.map((value , i ) => (
                                <div className="col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="blog blog-style--1">
                                        <div className="thumbnail">
                                            <a href="/blog-details">
                                                <img className="w-100" src={`/assets/images/blog/blog-${value.images}.jpg`} alt="Blog Images"/>
                                            </a>
                                        </div>
                                        <div className="content">
                                            <p className="blogtype">{value.category}</p>
                                            <h4 className="title"><a href="/blog-details">{value.title}</a></h4>
                                            <div className="blog-btn">
                                                <a className="rn-btn text-white" href="/blog-details">Read More</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div> */}
				{/* End Blog Area */}
				{/* Start Brand Area */}
				{/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
				{/* End Brand Area */}
				{/* Start Footer Area  */}
				<FooterTwo />
				{/* End Footer Area  */}
				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}
			</Fragment>
		);
	}
}
export default withStyles(styles)(MoonlineHome);
